<template>
  <div class="flex flex-col gap-5">
    <h3 class="text-EXPONDO-grey">
      {{ title }}
    </h3>
    <div class="flex flex-col gap-2">
      <ul class="flex flex-col gap-2">
        <li
          v-for="category in displayedCategories"
          :key="category.url"
          class="list-none"
        >
          <CustomLink
            :text="category.name"
            :url="category.url"
            :type="LINK_TYPE.Dark"
          />
        </li>
      </ul>
      <p
        v-if="isExpansionPossible"
        class="underline text-EXPONDO-secondary cursor-pointer"
        @click="onClick"
      >
        {{ $t(actionText) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">

import type { RelatedCategory } from '~~/types/category/RelatedCategory';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import { RELATED_CATEGORY_DISPLAY_LIMIT } from '~~/constants/relatedCategory';

export default defineComponent({
  name: 'RelatedCategories',

  props: {
    title: {
      type: String,
      required: true,
    },
    relatedCategories: {
      type: Array as PropType<RelatedCategory[]>,
      required: true,
    },
  },
  setup(props) {

    const isExpanded = ref(false);
    const isExpansionPossible = computed(() =>
      props.relatedCategories.length > RELATED_CATEGORY_DISPLAY_LIMIT,
    );
    const actionText = computed(() => isExpanded.value ? 'See less' : 'See more');
    const displayedCategories = computed(() => isExpanded.value
      ? props.relatedCategories
      : props.relatedCategories.slice(0, RELATED_CATEGORY_DISPLAY_LIMIT));

    const onClick = () => {

      isExpanded.value = !isExpanded.value;
    
    };

    return {
      isExpansionPossible,
      actionText,
      onClick,
      displayedCategories,
      LINK_TYPE,
    };
  
  },
});

</script>
